(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dgs-disc-rim"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    var root = document.documentElement;
    if (!root.classList.contains('dgs-v2') || root.classList.contains('dgs-v2-portal')) return;

    function syncRim(changedSelect) {
      var data = document.getElementById('dgs-rim-data');
      var wrap = document.getElementById('canvas-wrapper');
      if (!data || !wrap || wrap.dataset.dgsDiscProfile !== 'disc') return;
      var rows = Array.from(data.querySelectorAll('[data-rim-variant]'));
      var select = changedSelect || Array.from(document.querySelectorAll('select[name="id"]')).find(function (candidate) {
        return Array.from(candidate.options).some(function (option) {
          return rows.some(function (row) { return row.dataset.rimVariant === option.value; });
        });
      });
      var id = select ? select.value : data.dataset.initialVariant;
      var selected = rows.find(function (row) { return row.dataset.rimVariant === id; });
      var style = selected ? selected.dataset.rimStyle : 'none';
      var color = selected ? selected.dataset.rimColor : '';
      if (['black', 'white', 'glow', 'assorted', 'solid'].indexOf(style) === -1 || (style === 'solid' && !/^#[0-9a-f]{6}$/i.test(color))) style = 'none';
      if (style === 'none') wrap.removeAttribute('data-dgs-rim');
      else wrap.dataset.dgsRim = style;
      if (selected && selected.dataset.plateStyle === 'glow') wrap.dataset.dgsPlate = 'glow';
      else wrap.removeAttribute('data-dgs-plate');
      if (style === 'solid') wrap.style.setProperty('--dgs-rim-color', color);
      else wrap.style.removeProperty('--dgs-rim-color');

      var note = document.querySelector('.dgs-rim-note');
      var notice = document.querySelector('.v2-notice');
      if (note && notice) {
        if (note.parentNode !== notice) notice.appendChild(note);
        note.hidden = style === 'none';
        note.querySelector('[data-rim-assorted-note]').hidden = style !== 'assorted';
      }
    }

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches || !event.target.matches('select[name="id"]')) return;
      var data = document.getElementById('dgs-rim-data');
      if (!data) return;
      var knownSelect = Array.from(event.target.options).some(function (option) {
        return Array.from(data.querySelectorAll('[data-rim-variant]')).some(function (row) { return row.dataset.rimVariant === option.value; });
      });
      if (knownSelect) syncRim(event.target);
    }, true);
    document.addEventListener('click', function (event) {
      if (event.target.closest('#customize-disc-btn')) requestAnimationFrame(function () { syncRim(); });
    }, true);
    window.addEventListener('pageshow', function () { syncRim(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncRim(); });
    else syncRim();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dgs-ultimate-surface"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    var root = document.documentElement;
    if (!root.classList.contains('dgs-v2') || root.classList.contains('dgs-v2-portal')) return;
    var observer;

    function syncUltimate(changedSelect) {
      var data = document.getElementById('dgs-ultimate-data');
      var wrap = document.getElementById('canvas-wrapper');
      if (!data || !wrap || wrap.dataset.dgsDiscProfile !== 'ultimate') return;
      var rows = Array.from(data.querySelectorAll('[data-ultimate-variant]'));
      function belongs(select) {
        return Array.from(select.options).some(function (option) {
          return rows.some(function (row) { return row.dataset.ultimateVariant === option.value; });
        });
      }
      var select = changedSelect && belongs(changedSelect) ? changedSelect : Array.from(document.querySelectorAll('select[name="id"]')).find(belongs);
      var id = select ? select.value : data.dataset.initialVariant;
      var row = rows.find(function (item) { return item.dataset.ultimateVariant === id; });
      var mode = row ? row.dataset.printMode : '';
      var diameter = Number(data.dataset.discMm);
      var printDiameter = row ? Number(row.dataset.printMm) : 0;
      var ratio = printDiameter / diameter;
      var valid = ['center', 'full'].indexOf(mode) !== -1 && ratio >= 0.6 && ratio < 1;
      var previous = wrap.dataset.dgsUltimateRatio;
      var surface = wrap.querySelector('.dgs-ultimate-surface');
      var container = wrap.querySelector('.canvas-container');
      if (valid) {
        wrap.dataset.dgsUltimateMode = mode;
        wrap.dataset.dgsUltimateRatio = String(ratio);
        wrap.style.setProperty('--dgs-ultimate-ratio', String(ratio));
        if (surface) {
          var radius = diameter / 2;
          var inner = printDiameter / 2;
          var d = 'M0,' + radius + 'a' + radius + ',' + radius + ' 0 1,0 ' + diameter + ',0a' + radius + ',' + radius + ' 0 1,0 -' + diameter + ',0Z' +
            'M' + (radius - inner) + ',' + radius + 'a' + inner + ',' + inner + ' 0 1,0 ' + printDiameter + ',0a' + inner + ',' + inner + ' 0 1,0 -' + printDiameter + ',0Z';
          surface.querySelectorAll('[data-ultimate-shell]').forEach(function (path) { path.setAttribute('d', d); });
          surface.querySelector('.dgs-ultimate-blank-depth').setAttribute('r', String(inner));
        }
      } else {
        wrap.removeAttribute('data-dgs-ultimate-mode');
        wrap.removeAttribute('data-dgs-ultimate-ratio');
        wrap.style.removeProperty('--dgs-ultimate-ratio');
      }
      if (surface) {
        surface.hidden = !valid || !container;
        if (container && surface.parentNode !== container) container.appendChild(surface);
      }
      var note = document.querySelector('.dgs-ultimate-note');
      var notice = document.querySelector('.v2-notice');
      if (note && notice) {
        if (note.parentNode !== notice) notice.appendChild(note);
        note.hidden = !valid;
        note.querySelectorAll('[data-ultimate-note]').forEach(function (line) { line.hidden = line.dataset.ultimateNote !== mode; });
      }
      if (!observer) {
        observer = new MutationObserver(function () { syncUltimate(); });
        observer.observe(wrap, { childList: true, subtree: true });
      }
      /* Only geometry changes request the existing adapter's refit. No Fabric
         access, synthetic upload, new clipping or save-history operation. */
      if (previous !== wrap.dataset.dgsUltimateRatio) window.dispatchEvent(new Event('resize'));
    }
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('select[name="id"]')) syncUltimate(event.target);
    }, true);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('#customize-disc-btn')) requestAnimationFrame(function () { syncUltimate(); });
    }, true);
    window.addEventListener('pageshow', function () { syncUltimate(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncUltimate(); });
    else syncUltimate();
  })();
  } catch(e) { console.error(e); }
})();

})();
